export default function ButtonSettings({ icon, text, onClicked, disabled }) {
  return (
    <div className="settings-button" onClick={!disabled ? onClicked : () => {}}>
      {icon && icon}
      {text && text}
    </div>
  );
}
